import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App as AntdApp, ConfigProvider } from "antd";
import zhCN from "antd/locale/zh_CN";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import App from "./App";
import { RouteErrorBoundary } from "./components/ErrorBoundary";
import { GlobalApiErrorToast } from "./components/GlobalApiErrorToast";
import { AuthProvider } from "./contexts/AuthContext";
import { industrialTheme } from "./theme/industrial";
import "./index.css";
import "./theme/fonts.css"; // 自托管字体（无 CDN · 支持离线）
import "./theme/workdao.css"; // WorkDAO 设计系统变量（作用域 [data-ui="workdao"]，不影响 /cnc/*）

const router = createBrowserRouter([
  {
    path: "*",
    element: (
      <AuthProvider>
        {/* 最外面兜底的一层:公开页(登录、分享的报价)和布局自己出错时,至少有一句话,不是一张白页
                (这时候导航也没了,所以用的是不提导航的那句话)。登录以后的页面在各自的布局里还有一层,那一层坏了导航还在。 */}
        <RouteErrorBoundary scope="app">
          <App />
        </RouteErrorBoundary>
      </AuthProvider>
    ),
  },
]);

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <ConfigProvider locale={zhCN} theme={industrialTheme}>
      <AntdApp>
        <GlobalApiErrorToast />
        <RouterProvider router={router} />
      </AntdApp>
    </ConfigProvider>
  </StrictMode>,
);
